export enum ShippingOptionType {
    SHIP_TO = 'shipping',
    BOPIS = 'in-store-pickup',
    SDD = 'same-day-delivery',
}

export interface ShippingOption {
    enabled: boolean;
    type: ShippingOptionType;
    price?: number;
}

export type ShippingOptions = ShippingOption[];
